import { openBlock, createElementBlock, createElementVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {};
const _hoisted_1 = {
  width: "17",
  height: "15",
  viewBox: "0 0 17 15",
  stroke: "none",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.4",
  d: "M8.43683 2.18384L1.875 7.92529V13.125C1.875 14.1605 2.71447 15 3.75 15H13.1242C14.1596 15 14.9992 14.1605 14.9992 13.125V7.92573L8.43683 2.18384ZM11.6504 9.25133C11.6504 9.70165 11.4839 10.1521 11.1509 10.4975L8.71966 13.0041C8.64076 13.0847 8.53857 13.125 8.43639 13.125C8.3342 13.125 8.23195 13.0847 8.15306 13.0041L5.72183 10.4975C5.38852 10.1517 5.22208 9.7006 5.22208 9.24978C5.22208 8.38452 5.87856 7.49996 6.89974 7.49996C7.36682 7.49996 7.83691 7.69294 8.18534 8.05312L8.43281 8.30958L8.68022 8.05312C9.03067 7.69294 9.50276 7.49996 9.97058 7.49996C10.9873 7.49996 11.6504 8.3815 11.6504 9.25133Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.97125 7.49994C9.50344 7.49994 9.03138 7.69292 8.68093 8.0531L8.43349 8.30956L8.18602 8.0531C7.83759 7.69292 7.36752 7.49994 6.90044 7.49994C5.88067 7.49994 5.22275 8.3823 5.22275 9.24976C5.22275 9.70058 5.38922 10.1516 5.7225 10.4974L8.15373 13.004C8.23266 13.0847 8.33487 13.125 8.43706 13.125C8.53925 13.125 8.64146 13.0847 8.72033 13.004L11.1517 10.4974C11.4846 10.152 11.651 9.70163 11.651 9.25131C11.651 8.38523 10.9893 7.49994 9.97125 7.49994ZM16.555 6.79418L14.9998 5.43349V1.40578C14.9998 1.14715 14.7902 0.937031 14.5311 0.937031H12.6562C12.3971 0.937031 12.1875 1.14715 12.1875 1.40578V2.97284L9.05502 0.23209C8.87833 0.077373 8.6579 0 8.4375 0C8.2171 0 7.99667 0.077373 7.81998 0.23209L0.31998 6.79418C0.0778125 7.00649 0 7.28446 0 7.50023C0 8.21133 0.644209 8.43744 0.9375 8.4375C1.15655 8.4375 1.37666 8.36121 1.55502 8.20582L8.4375 2.18382L15.32 8.20582C15.498 8.36145 15.7182 8.43744 15.937 8.43744C16.2253 8.43744 16.875 8.21115 16.875 7.50023C16.875 7.28405 16.7967 7.00611 16.555 6.79418Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const HomeHeartIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  HomeHeartIcon as default
};
//# sourceMappingURL=HomeHeartIcon.vue.es.js.map
